import { getSrcs } from '@helpers/image';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import React from 'react';
import Breadcrumb from '../Global/Breadcrumb/Breadcrumb';
import { InnerPageBannerStyles as S } from './InnerPageBanner.styles';
const InnerPageBanner = ({ breadcrumb, content, image, link, theme, title, }) => {
    const [citationOpen, setCitationOpen] = React.useState(false);
    const srcs = getSrcs(image, 1300, 425, 8, 425 / 1300);
    return (React.createElement(S.Container, { flush: "top", theme: theme },
        React.createElement(S.Inner, null,
            React.createElement(S.MediaArea, null,
                srcs && (React.createElement(S.PromoMedia, null,
                    React.createElement(S.PromoImage, { alt: image.altText ?? '', loading: "eager", role: image.altText ? undefined : 'presentation', src: srcs[0].split(' ')[0], srcSet: srcs.join(','), width: "1300", height: "425" }))),
                image.citation && (React.createElement(S.CitationBtn, { type: "button", "data-citation-open": citationOpen, onClick: () => setCitationOpen(!citationOpen) },
                    React.createElement(S.CitationIcon, null, "i"),
                    React.createElement(S.CitationContent, null, image.citation)))),
            React.createElement(S.ContentArea, null,
                breadcrumb && React.createElement(Breadcrumb, { items: breadcrumb }),
                React.createElement(S.BannerTitle, null, title),
                content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }),
                link && (React.createElement(S.CtaArea, null,
                    React.createElement(LinkButton, { styleType: "solid", title: link?.text ?? 'Find out more', href: link?.url, target: link?.target ?? '_self', id: link?.id, "data-element-theme": theme })))))));
};
export default InnerPageBanner;
